<template>
  <div class="shared-link-delete-dialog-box">

    <el-dialog
      :title="$t('wre-dashboard.shared-link-dialog-box.delete-view.title')"
      @close="onCancel()"
      :show-close="false"
      visible>

      <div class="mx-24 my-24 el-text el-text--size-xs">
        <div style="margin-top: 13px; margin-bottom: -4px;">
          {{ $t('wre-dashboard.shared-link-dialog-box.delete-view.message') }}
        </div>
      </div>

      <template #footer>
        <el-button
          @click="onCancel()"
          native-type="button"
          type="secondary">
          {{ $t('wre-dashboard.form.button.cancel') }}
        </el-button>

        <el-button
          native-type="button"
          @click="onDelete()"
          :loading="isDeleteSharedLinkInProgress"
          :disabled="isDeleteSharedLinkInProgress"
        >
          {{ $t('wre-dashboard.form.button.delete') }}
        </el-button>

      </template>
    </el-dialog>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { DELETE_SHARED_LINK } from '../store/action-types';

import { COMPLETED_STATUS, PENDING_STATUS } from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('wre-dashboard');

export default {
  name: 'SharedLinkDeleteDialogBox',
  props: {
    linkId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'getDeleteSharedLinkStatus'
    ]),
    isDeleteSharedLinkInProgress() {
      return this.getDeleteSharedLinkStatus === PENDING_STATUS;
    },
    isDeleteSharedLinkCompleted() {
      return this.getDeleteSharedLinkStatus === COMPLETED_STATUS;
    }
  },
  watch: {
    isDeleteSharedLinkCompleted() {
      this.onClose();
    }
  },
  methods: {
    ...mapActions({
      deleteSharedLink: DELETE_SHARED_LINK
    }),
    onDelete() {
      this.deleteSharedLink({
        linkId: this.linkId
      });
    },
    onCancel() {
      this.$emit('handleCancel');
    },
    onClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
